export function getCookie(cname: string): string {
    const name = cname + "=";
    const ca = document.cookie.split(";");
    for (let c of ca) {
        while (c.startsWith(" ")) {
            c = c.substring(1);
        }
        if (c.startsWith(name)) {
            return decodeURIComponent(c.substring(name.length));
        }
    }
    return "";
}

export function initializeCookiesBar() {
    const COOKIE_NAME = "digitalpresence.cookielevelselection";
    const COOKIE_LEVEL_NAME = "digitalpresence.cookieconsentlevel";
    const cookieForm = document.getElementById("cookieBannerForm") as HTMLFormElement | null;
    const cookieBar = document.querySelector<HTMLElement>(".js-cookiebanner");
    const cookieDialog = cookieBar?.querySelector<HTMLDialogElement>(".cookie-banner-modal");
    const hasTextSelection = () => !!window.getSelection()?.toString().trim();

    const hideBanner = () => {
        if (!cookieBar) {
            return;
        }

        cookieBar.classList.add("hidden");
        cookieBar.hidden = true;

        if (cookieDialog?.open) {
            cookieDialog.close();
        }
    };

    const showBanner = () => {
        if (!cookieBar) {
            return;
        }

        cookieBar.hidden = false;
        cookieBar.classList.remove("hidden");

        if (cookieDialog && !cookieDialog.open) {
            cookieDialog.setAttribute("open", "");
        }
    };

    const cookieValue = getCookie(COOKIE_NAME);
    const cookieLevelValue = getCookie(COOKIE_LEVEL_NAME);

    if (!cookieBar) {
        return;
    }

    if (cookieValue === "true" || cookieLevelValue === "4") {
        hideBanner();
        return;
    }

    showBanner();

    const cookieBarCtas = document.querySelectorAll(".js-close-cookie");
    const cookieBarLinks = cookieBar.querySelectorAll<HTMLAnchorElement>("a");

    cookieBarCtas.forEach(function (elem) {
        elem.addEventListener("click", () => {
            hideBanner();
        });
    });

    cookieBarLinks.forEach((link) => {
        link.addEventListener("click", (event) => {
            if (hasTextSelection()) {
                event.preventDefault();
            }
        });
    });

    // Ensure the modal is dismissed whenever the Accept All form submit occurs.
    cookieForm?.addEventListener("submit", () => {
        hideBanner();
    });
}

document.addEventListener("DOMContentLoaded", () => {
    initializeCookiesBar();
});
